import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import moment from 'moment';
import { map } from 'rxjs';
import { TranslateService } from '../core/translate';

@Injectable({
    providedIn: 'root'
})
export class CustomDateAdapter extends NativeDateAdapter {
    public constructor(private readonly translateService: TranslateService) {
        super('en');
        this.translateService.currentLang$
            .pipe(
                map(lang => {
                    this.setLocale('en');
                })
            )
            .subscribe();
    }

    override getFirstDayOfWeek(): number {
        return 0;
    }

    override format(date: Date): string {
        this.translateService.currentLang$
            .pipe(
                map(lang => {
                    moment.locale('en');
                })
            )
            .subscribe();
        return moment(date).format('D MMMM YYYY');
    }

    override getDayOfWeekNames(type) {
        if (type === 'long' || type === 'narrow') {
            return Object.values(
                this.translateService.instant([
                    'weekDays.sunday',
                    'weekDays.monday',
                    'weekDays.tuesday',
                    'weekDays.wednesday',
                    'weekDays.thursday',
                    'weekDays.friday',
                    'weekDays.saturday'
                ])
            ) as string[];
        } else {
            return [];
        }
    }
}
